@if (isLoading) {
    <div style="position: absolute; z-index: 10; font-size: xx-large; left: 50%; top: 50%">Loading...</div>
}
<div style="height: 95%" [ngStyle]="isLoading && { filter: 'blur(8px)' }">
    @if (canEdit) {
        <div style="height: 60px; text-align: center">
            <label mat-label style="margin-top: 20px; color: red; font-size: large; font-style: italic; top: 50%; position: relative">Edit Mode</label>
            <button mat-raised-button color="primary" style="float: right; margin-top: 10px; margin-right: 10px" [disabled]="hasWeightErrors || hasDateErrors" (click)="onSave()">
                Save
            </button>
            <button mat-raised-button color="primary" style="float: right; margin-top: 10px; margin-right: 10px" (click)="onStopEdit()">Cancel</button>
            @if (hasWeightErrors || hasDateErrors) {
                <label mat-label style="float: right; margin-top: 20px; margin-right: 10px; font-style: italic; color: red">*Cannot save because document contains errors</label>
            }
        </div>
    }
    <kendo-spreadsheet #excelChild [sheets]="sheets" (change)="onSpreadsheetChange()" style="width: 100%; height: 90%" [ngStyle]="canEdit && { border: '8px solid red' }">
    </kendo-spreadsheet>
</div>
